/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { launcherJudge } from "../funcs/launcherJudge.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { LauncherJudgment } from "../models/components/launcherjudgment.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  LauncherJudgeRequest,
  LauncherJudgeSecurity,
} from "../models/operations/launcherjudge.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type LauncherJudgeMutationVariables = {
  request: LauncherJudgeRequest;
  security?: LauncherJudgeSecurity | undefined;
  options?: RequestOptions;
};

export type LauncherJudgeMutationData = LauncherJudgment;

export type LauncherJudgeMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * judge launcher
 *
 * @remarks
 * Judge which of the supplied command palette candidates the typed query refers to, what kind of action it asks for, and whether the intent is settled enough to act on Enter. Returns probability distributions rather than text. When no intent service is configured the response carries disabled=true and the palette falls back to fuzzy ordering.
 */
export function useLauncherJudgeMutation(
  options?: MutationHookOptions<
    LauncherJudgeMutationData,
    LauncherJudgeMutationError,
    LauncherJudgeMutationVariables
  >,
): UseMutationResult<
  LauncherJudgeMutationData,
  LauncherJudgeMutationError,
  LauncherJudgeMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildLauncherJudgeMutation(client, options),
    ...options,
  });
}

export function mutationKeyLauncherJudge(): MutationKey {
  return ["@gram/client", "launcher", "judge"];
}

export function buildLauncherJudgeMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: LauncherJudgeMutationVariables,
  ) => Promise<LauncherJudgeMutationData>;
} {
  return {
    mutationKey: mutationKeyLauncherJudge(),
    mutationFn: function launcherJudgeMutationFn({
      request,
      security,
      options,
    }): Promise<LauncherJudgeMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(launcherJudge(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
